export type ProjectsTimelineSidenavTab = 'range' | 'pause' | 'stage';

export const timelineSidenavTabs: { type: ProjectsTimelineSidenavTab; name: string; isActive: boolean }[] = [
  {
    type: 'range',
    name: 'Projects.Period.title',
    isActive: true
  },
  {
    type: 'pause',
    name: 'Projects.Pause.title',
    isActive: false
  },
  {
    type: 'stage',
    name: 'Projects.Stages.title',
    isActive: false
  }
];
